import React from 'react';
import { graphql } from 'gatsby';
import SiteHeader from '../components/SiteHeader/SiteHeader';
import Container from '../components/Container/Container';
import ParagraphHeader from '../components/Paragraph/ParagraphHeader';
import Paragraph from '../components/Paragraph/Paragraph';
import MasonryGallery from '../components/MasonryGallery/MasonryGallery';

const Lamps = ({ data }) => {
  return (
    <>
      <SiteHeader
        image={data.file.childImageSharp.gatsbyImageData}
        text='Pomysł na lampę'
      />
      <Container padding='32px 16px' width='740px'>
        <ParagraphHeader>Wytapetuj sobie... lampę</ParagraphHeader>
        <Paragraph>
          Jesteśmy całym sercem za ideą upcyklingu, czyli kreatywnego
          wykorzystywania resztek tkanin i tapet, które zostały po aranżacji.
          Wpadłyśmy na pomysł podjęcia współpracy z manufakturą lamp, która
          specjalnie dla Państwa wykona abażury z powierzonych jej materiałów.
          Jeśli zatem szukacie idealnie pasującej do wnętrza lampy, możemy
          zlecić jej wykonanie z resztki tapety, która zdobi Waszą ścianę, bądź
          z tkaniny, której nadmiar został po szyciu zasłon. Można dowolnie
          łączyć ze sobą materiały wewnątrz i na zewnątrz abażura, jak również
          decydować o jego rozmiarze i kolorze wykończenia. Na ekspozycji w
          naszym salonie znajdziecie Państwo wiele pomysłów na ten produkt.
        </Paragraph>
      </Container>
      <Container fluid>
        <MasonryGallery data={data.lamps.edges} />
      </Container>
    </>
  );
};

export const query = graphql`
  {
    file(name: { eq: "IMG_20220104_123359" }) {
      childImageSharp {
        gatsbyImageData
      }
    }
    wallpaper: file(name: { eq: "fototapeta_1" }) {
      childImageSharp {
        gatsbyImageData(width: 1200, placeholder: BLURRED, quality: 80)
      }
    }
    lamps: allFile(filter: { relativeDirectory: { eq: "Lampy" } }) {
      edges {
        node {
          id
          publicURL
          childImageSharp {
            gatsbyImageData(placeholder: BLURRED, quality: 80)
          }
        }
      }
    }
  }
`;

export default Lamps;
